import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const UsbIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 7L15 11L16 11L16 13L13 13L13 5L15 5L12 1L9 5L11 5L11 13L8 13L8 10.93C8.7 10.56 9.2 9.85 9.2 9C9.2 7.79 8.21 6.8 7 6.8S4.8 7.79 4.8 9C4.8 9.85 5.3 10.56 6 10.93L6 13C6 14.11 6.89 15 8 15L11 15L11 18.05C10.29 18.42 9.8 19.15 9.8 20C9.8 21.22 10.79 22.2 12 22.2S14.2 21.22 14.2 20C14.2 19.15 13.71 18.42 13 18.05L13 15L16 15C17.11 15 18 14.11 18 13L18 11L19 11L19 7L15 7Z"
      fill="currentColor"
    />
  </svg>
);

UsbIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(UsbIcon);
